function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.4852 14.7556C17.307 13.4918 19 10.8852 19 8.5C19 5 16 2 12 2C8 2 5 5 5 8.5C5 10.8852 6.69297 13.4918 8.51479 14.7556C8.50503 14.8357 8.5 14.9173 8.5 15V16C8.5 16.5 9 17 9.5 17H14.5C15 17 15.5 16.5 15.5 16V15C15.5 14.9173 15.495 14.8357 15.4852 14.7556ZM9.25 18.75C9.25 18.3358 9.58579 18 10 18H14C14.4142 18 14.75 18.3358 14.75 18.75C14.75 19.1642 14.4142 19.5 14 19.5H10C9.58579 19.5 9.25 19.1642 9.25 18.75ZM11 20.25C10.5858 20.25 10.25 20.5858 10.25 21C10.25 21.4142 10.5858 21.75 11 21.75H13C13.4142 21.75 13.75 21.4142 13.75 21C13.75 20.5858 13.4142 20.25 13 20.25H11Z",
  fill: "white"
});

function SvgTips(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/Tips.d588ec59841ca391d042b7ec4d66a242.svg";
export { ForwardRef as ReactComponent };